import React, { useEffect } from 'react';
import $ from 'jquery';
import * as R from "ramda";

import { DateWithModal } from '../../../../_common/dateWithModal';
import { fetchInvoiceLines, markPartnersInvoicesPaid } from '../../../../actions/backoffice/payments';
import { AssuranceOptions, AssuranceOptionsBO, CommonServices, ConnectionTypes, convertConnectionTypesToServiceType, OtherService, PersonalServices, SocialNetworksOptions } from '../../../../constants/utils/connectionTypes';
import { useDispatch } from 'react-redux';



export const ServiceTableRow = ({ serviceType, organizationName, name, address, urls, service, setSelectedService }) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dispatch = useDispatch();
    const options = { style: 'currency', currency: 'EUR' };


    return (
			<div className="card p-2 mt-1">
				<div className="row g-1 align-items-center">
					<div className="col text-truncate col-md-2">
						<div className={"h5 ls-1 my-auto text-truncate"}>{serviceType?.title.toUpperCase()}</div>
					</div>
					<div className="col text-truncate">
						{/* <div className={"h5 ls-1 my-auto text-truncate" + (recipientType === "Etablissement" ? "" : " o-50")}>{recipientType === "Etablissement" ? etablissementName : ""}</div> */}
						<div className={"h5 ls-1 my-auto text-truncate"}>
							<span className="align-middle">{organizationName}</span>{" "}
							{/*!R.isEmpty(urls) && <a href={urls} target="_blank" rel="noopener noreferrer" className="o-60 o-100--hover align-middle"><i className="eva eva-link-outline align-middle" data-toggle="tooltip" title={urls} data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i></a>*/}
						</div>
					</div>
					<div className="col-auto col-md">
						<div className="h5 ls-1 my-auto o-70">{name}</div>
					</div>
					<div className="col">
						<div className="h5 ls-1 my-auto container-press ml-auto ">
							{!R.isEmpty(urls) && !R.isNil(urls)
								? urls.map((url, i) => (
										<React.Fragment key={address + i}>
											<a href={url.address} target="_blank" rel="noopener noreferrer" className="o-60 o-100--hover align-middle">
												{url.address}
											</a>
											<br />
										</React.Fragment>
								  ))
								: ""}
						</div>
						{R.isEmpty(urls) || R.isNil(urls) ? (
							<div className="h5 ls-1 my-auto container-press ml-auto ">
								{" "}
								{address.streetAddress} {address.streetAddress2} {address.streetAddress3} {address.postalCode} {address.addressLocality} {address.addressCountry}
							</div>
						) : (
							""
						)}
					</div>
					<div className="col-12 d-md-none">
						<hr className="my-0" />
					</div>
					<div className="col-12 col-md-3 col-xl-1 ml-auto flex-row justify-content-md-end">
						<button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#editServiceModal" onClick={() => setSelectedService(service)}>
							<i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
						</button>
						<button type="button" className="btn btn-icon btn-stage-danger shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#deleteServiceModal" onClick={() => setSelectedService(service)}>
							<i className="eva eva-trash-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Supprimer" data-template='<div class="tooltip tooltip-white-danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
						</button>
					</div>
				</div>
			</div>
		);
};